import * as aircoreMedia from '@aircore/aircore-media';
import {isSatConfiguration} from './util';

export interface SatConfiguration {
  sat: string;
}

export interface PakConfiguration {
  pak: string;
  userId: string;
  channelId: string;
  allowPublishAudio: boolean;
  allowPublishVideo: boolean;
  allowPublishScreenShare: boolean;
  allowBotChat: boolean;
  allowVoiceDataCollection: boolean;
  tokenLifetimeSec: number | undefined;
}

export type ChannelConfiguration = (PakConfiguration | SatConfiguration) & {
  metadata: string | undefined;
};

export type AppConfiguration = PakConfiguration & {
  metadata: string | undefined;
  userAgent: string | undefined;
  mediaServiceUrl: string | undefined;
  mediaServiceEnv: string | undefined;
};

/**
 * Represents a Channel/Configuration combination.
 *
 * Auto increments the ID for each new instance so it can be mapped to the UI.
 */
export class PineridgeChannel {
  private static nextId = 0;

  mediaChannel: aircoreMedia.Channel;
  config: ChannelConfiguration;
  pineridgeChannelId: number;
  isSatChannel: boolean;

  get loggingId(): string {
    if (this.mediaChannel.channelId.length === 0 && this.isSatChannel) {
      return `[${this.pineridgeChannelId}] Unknown`;
    }
    return `[${this.pineridgeChannelId}] ${this.mediaChannel.channelId}`;
  }

  /**
   * @param channel Big Sur Channel to wrap
   * @param config Configuration used to create the channel
   */
  constructor(channel: aircoreMedia.Channel, config: ChannelConfiguration) {
    this.mediaChannel = channel;
    this.config = config;
    this.pineridgeChannelId = PineridgeChannel.nextId++;
    this.isSatChannel = isSatConfiguration(config);
  }
}
